/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { current } from "@reduxjs/toolkit"
import { ReactElement } from "react"
import "./Paginator.css"

export type PaginatorProps = {
  totalItems: number
  itemsPerPage: number
  //totalPages: number
  currentPage: number
  onClick: Function
  nextLabel: string
  prevLabel: string
}

type PageNumber = {
  label: string
  value: number | null
}

const MAX_VISIBLE_PAGES = 7
const ACTION_DIR = "pagination.direction"
const ACTION_GOTO = "pagination.goto"

export function Paginator({
  itemsPerPage,
  totalItems,
  currentPage,
  nextLabel,
  prevLabel,
  onClick,
}: PaginatorProps) {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const pages: PageNumber[] = []

  const onChange = (action: string, value: number) => {
    if (typeof onClick === "function") {
      switch (action) {
        case ACTION_GOTO:
          onClick(value)
          break
        case ACTION_DIR:
          onClick(currentPage + value)
      }
    }
  }

  const printPage = (page: PageNumber, index: number): ReactElement => {
    const key: string = "page-number-" + index
    if (!page.value) {
      return (
        <span key={key} className="av-bar">
          {page.label}
        </span>
      )
    } else {
      const isActive = page.value === currentPage
      return (
        <a
          key={key}
          href="#"
          className={["av-language-button", isActive ? "av-active" : ""].join(
            " ",
          )}
          onClick={(evt: any) => {
            evt.preventDefault()
            !isActive && typeof page.value === "number"
              ? onChange(ACTION_GOTO, page.value)
              : null
          }}
        >
          {page.label}
        </a>
      )
    }
  }

  const printArrow = (isPrev: boolean = false) => {
    const isDisabled: boolean = isPrev
      ? currentPage === 1
      : currentPage === totalPages
    return (
      <a
        href="#"
        onClick={(evt: any) => {
          evt.preventDefault()
          !isDisabled ? onChange(ACTION_DIR, isPrev ? -1 : 1) : null
        }}
        className={[
          "av-paginator-arrow",
          isPrev ? "av-prev-icon" : "av-next-icon",
          "av-icon",
          isPrev ? "icon-icon_14" : "icon-icon_15",
          isDisabled ? "av-disabled" : "",
        ].join(" ")}
      >
        <span className="sr-only">{isPrev ? prevLabel : nextLabel}</span>
      </a>
    )
  }

  if (currentPage <= MAX_VISIBLE_PAGES) {
    //primo intervallo di pagine
    const end = totalPages < MAX_VISIBLE_PAGES ? totalPages : MAX_VISIBLE_PAGES
    for (let i = 1; i <= end; i++) {
      pages.push({
        label: i + "",
        value: i,
      })
    }

    if (totalPages > MAX_VISIBLE_PAGES + 1) {
      pages.push({
        label: "...",
        value: null,
      })
    }

    if (totalPages > MAX_VISIBLE_PAGES) {
      pages.push({
        label: totalPages + "",
        value: totalPages,
      })
    }
  } else if (currentPage >= totalPages - MAX_VISIBLE_PAGES) {
    //ultimo intervallo di pagine
    for (let i = totalPages; i > totalPages - MAX_VISIBLE_PAGES; i--) {
      pages.unshift({
        label: i + "",
        value: i,
      })
    }

    if (totalPages - MAX_VISIBLE_PAGES - 1 > 0) {
      pages.unshift({
        label: "...",
        value: null,
      })
    }
    pages.unshift({
      label: 1 + "",
      value: 1,
    })
  } else {
    //intervalli di pagine intermedi
    pages.push({
      label: 1 + "",
      value: 1,
    })
    pages.push({
      label: "...",
      value: null,
    })
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      pages.push({
        label: i + "",
        value: i,
      })
    }
    pages.push({
      label: "...",
      value: null,
    })
    pages.push({
      label: totalPages + "",
      value: totalPages,
    })
  }

  if (totalPages <= 1) {
    return null
  }

  return (
    <div className="av-paginator-wrapper">
      {/*MOBILE*/}
      <div className="av-pager-mobile visible-xs visible-sm">
        {printArrow(true)}

        {/*class av-disabled for disabled arrow*/}
        <div className="av-paginator">
          {printPage({ label: currentPage + "", value: currentPage }, 1)}
          <span className="av-bar"> / </span>
          {printPage({ label: totalPages + "", value: totalPages }, 2)}
        </div>

        {printArrow(false)}
      </div>

      {/*DESKTOP*/}
      <div className="av-pager-mobile hidden-xs hidden-sm">
        {printArrow(true)}

        {/*class av-disabled for disabled arrow*/}
        <div className="av-paginator">
          {pages.map((page, index) => printPage(page, index))}
        </div>

        {printArrow(false)}
      </div>
    </div>
  )
}
